<form *transloco="let t" [formGroup]="form">
  <div class="flex items-start justify-between border-b border-border-normal py-4">
    <div class="flex w-full max-w-96 flex-col gap-2">
      <label class="font-medium text-primary" htmlFor="isOpen">
        {{ t('Collaboration ouverte') }}
      </label>
      <span class="text-sm text-text-tertiary">
        {{
          t(
            'Lorsque la collaboration est activée, tous les utilisateurs du groupe peuvent voir les séquences des uns et des autres.'
          )
        }}
      </span>
    </div>
    <input data-testid="isOpen" formControlName="isOpen" id="isOpen" size="m" tuiSwitch type="checkbox" />
  </div>
  <div class="flex items-center justify-between border-b border-border-normal py-4">
    <div class="flex w-full max-w-96 flex-col gap-2">
      <label class="font-medium text-primary" htmlFor="medicalSpecialtyId">
        {{ t('Spécialité médicale') }}
      </label>
    </div>
    <pxc-medical-specialty-picker
      class="w-full max-w-96"
      formControlName="medicalSpecialtyId"
      id="medicalSpecialtyId"
      [showLabel]="false" />
  </div>
</form>
